import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'

const liability_cancelled = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('cancelled_by_previous_insurer')]: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_liabilityNxt:steps.liability.cancelled.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('cancelled_by_previous_insurer'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.no',
            },
            value: false,
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('cancelled_by_previous_insurer'),
      valueToStepName: {
        true: FAILURE_STEP_NAME,
        false: 'liability_drone',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default liability_cancelled
